import { useInfiniteQuery } from 'react-query';
import { projects_history } from '../constants/Keys';

import { getDonationHistory as getProjects } from '../global/helpers';

export const useFetchProjects = (params) => {
  const getDonationHistory = async ({ pageParam = 0 }) => {
    return getProjects({ ...params, offset: pageParam }).then((resp) => resp.data);
  };

  return useInfiniteQuery(projects_history, getDonationHistory, {
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.data.length === 0) return undefined;
      if (lastPage.data.length <= 10) {
        return pages[pages.length - 1].offset + lastPage.data.length;
      }
    },
    retry: false,
  });
};
